import React from "react";
import { useLocation } from "react-router-dom";
import { SupersetEmbedReport } from "../components";

const DASHBOARD_ID = "71753aff-019a-4efa-a059-0f3cd4d16d96";

export const ProductSalesWastageReport = () => {
  const { pathname } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");

  const breadcrumbLinks = [
    { name: "Dashboard", href: isStoreAdmin ? "/store-admin" : "/" },
    { name: "External Reports" },
    { name: "Product Sales & Wastage Report" },
  ];

  return (
    <SupersetEmbedReport
      title="Product Sales & Wastage Report"
      dashboardId={DASHBOARD_ID}
      breadcrumbLinks={breadcrumbLinks}
    />
  );
};
